<template>
  <div class="page_search_area">
    <el-form :inline="true">
      <el-form-item label="省份：" class="search_item_area">
        <el-select
          v-model="searchData.province"
          placeholder="请选择"
          @change="selectProvinceChange"
        >
          <el-option
            v-for="item in arrProvinces"
            :key="item.areaId"
            :label="item.areaName"
            :value="item.areaId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市：" class="search_item_area">
        <el-select
          v-model="searchData.city"
          placeholder="请选择"
          :disabled="searchData.province == ''"
        >
          <el-option
            v-for="item in arrCitys"
            :key="item.areaId"
            :label="item.areaName"
            :value="item.areaId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位简称：" class="search_item_area">
        <el-input
          placeholder="请输入单位简称"
          v-model.trim="searchData.appShortName"
          maxlength="30"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="单位编码：" class="search_item_area">
        <el-input
          placeholder="请输入单位编码"
          v-model.trim="searchData.appCode"
          maxlength="30"
          @input="(v) => {
                  this.searchData.appCode = v.replace(/[^\d]/g, '');
                }"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item class="search_item_area">
        <el-button class="search_btn" type="primary" @click="btnSeachClick"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixins from "./Mixins";
export default {
  mixins: [mixins],
  data() {
    return {
      isAdmin:false,
      arrCitys: [],
    };
  },
  computed: {
    searchData() {
      return this.Unit.searchData;
    },
    arrUnitTypes() {
      return this.Unit.arrUnitTypes;
    },
    arrProvinces: {
      get(){
        return this.Unit.arrProvinces;
      },
      set(v) {
        this.SETOPTIONS({
          arrProvinces:v
        })
      }
    }
  },
  async created() {
    let userInfo = JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo"));
    this.isAdmin = !userInfo.validateRole

    // 单位分类
    await this.getUnitType_A();
    if (this.arrUnitTypes.length > 0) {
      this.SETOPTIONS({
        activeTabId: this.arrUnitTypes[0].id,
        pageData: {
          page: 1,
          size: 20,
          total: 0,
        },
      });

      this.getTableList_A();
    }

    let arrProvinces = await this.getProvinceOrCity_A({
      parentId: 1,
      query: true,
    });
    let total = {
      areaId: "",
      areaName: "全部",
      areaPinyin: "quan bu",
      fileName: "",
      parentId: 1,
      state: 1,
    };
    arrProvinces.unshift(total);
    this.arrProvinces = arrProvinces;
  },
  methods: {
    async selectProvinceChange() {
      this.setSearchData_M({
        city: "",
      });
      if (this.searchData.province != "") {
        let arrCitys = await this.getProvinceOrCity_A({
          parentId: this.searchData.province,
          query: true,
        });
        let total = {
          areaId: "",
          areaName: "全部",
          areaPinyin: "quan bu",
          fileName: "",
          parentId: this.searchData.province,
          state: 1,
        };
        arrCitys.unshift(total);
        this.arrCitys = arrCitys;
      }
    },
    btnSeachClick() {
      this.SETOPTIONS({
        pageData: {
          page: 1,
          size: 20,
          total: 0,
        },
      });

      this.getTableList_A();
    },
  },
};
</script>

<style lang="stylus" scoped>
.page_search_area {
  height: 80px;

  .btn_out {
    background-color: #F66915;
    width: 100px;
    height: 40px;
    float: right;
    margin-top: -60px;
    margin-right: 30px;
    color: #fff;
    padding: 0 20px;

    .btn_content {
      display: flex;
      align-items: center;
    }

    .icon-upload {
      background: url('~@/assets/images/Statistics/icon_out.png') no-repeat;
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 10px;
    }

    .text_upload {
      display: inline-block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/UnitManagement/components/unitSearch.vue